import type { PortalUser } from './api'

/** Presentation hint only; the Worker independently enforces the invariant. */
export function isLastFullAccess(users: PortalUser[], email: string): boolean {
  const target = users.find(u => u.active && u.email.toLowerCase() === email.toLowerCase())
  if (!target || (target.accessLevel ?? 'full') !== 'full') return false
  return !users.some(u =>
    u.active
    && u.email.toLowerCase() !== email.toLowerCase()
    && (u.accessLevel ?? 'full') === 'full',
  )
}
